export const formatNumber = (
    value: number | string,
    minimumFractionDigits = 0,
    maximumFractionDigits = 5,
): string => {
    if (Number.isNaN(Number(value))) {
        return '0';
    }

    // Preserve user input like ".0" or "." while typing
    if (typeof value === 'string') {
        if (value === '' || value === '.' || value.match(/^\d+\.$|^\d+\.\d*$/)) {
            return value;
        }
    }

    const numericValue = Number(value);

    if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') {
        try {
            const hasDecimal = numericValue % 1 !== 0;

            if (hasDecimal) {
                return new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits,
                }).format(numericValue);
            }

            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits,
                maximumFractionDigits,
            }).format(numericValue);
        } catch (e) {
            return numericValue.toString();
        }
    }

    return numericValue.toString();
};
